<script lang="ts">
    import CN from "classnames";

    let className = "";
    export { className as class };

    export let disabled = false;
    export let block = false;
    export let role: string | null = null;
    export let ariaLabel: string | null = null;
    export let ariaControls: string | null = null;
    export let ariaExpanded: boolean | null = null;
    export let ariaSelected: boolean | null = null;
    export let dataSelector: string | undefined = undefined;
    export let withoutReset = false;
    export let url: string | null = null;
    export let target: "_self" | "_parent" | "_top" | "_blank" | undefined =
        undefined;
    export let rel: string | undefined = undefined;
    export let type: "button" | "submit" | "reset" = "button";

    export let element: HTMLElement | null = null;

    $: classes = CN(
        "gw-btn",
        {
            "gw-btn--reset": !withoutReset,
        },
        className
    );
</script>

{#if url}
    <a
        href={url}
        {target}
        {role}
        {rel}
        class={classes}
        class:gw-btn--block={block}
        aria-label={ariaLabel}
        aria-controls={ariaControls}
        aria-expanded={ariaExpanded}
        aria-selected={ariaSelected}
        aria-disabled={disabled}
        data-gw-selector={dataSelector}
        on:click
        on:mouseover
        on:focus
        on:mousedown
        on:mouseup
        on:mouseleave
        on:blur
        bind:this={element}
        {...$$restProps}
    >
        <slot />
    </a>
{:else}
    <button
        {role}
        class={classes}
        class:gw-btn--block={block}
        {disabled}
        {type}
        aria-label={ariaLabel}
        aria-controls={ariaControls}
        aria-expanded={ariaExpanded}
        aria-selected={ariaSelected}
        aria-disabled={disabled}
        data-gw-selector={dataSelector}
        on:click
        on:mouseover
        on:focus
        on:mousedown
        on:mouseup
        on:mouseleave
        on:blur
        bind:this={element}
        {...$$restProps}
    >
        <slot />
    </button>
{/if}

<style lang="postcss" global>
    .gw-btn {
    }
    .gw-btn--reset {
        min-width: unset;
        min-height: unset;
        font-family: inherit;
        margin: 0;
        padding: 0;
        border: none;
        cursor: pointer;
        background: transparent;
        font-size: inherit;
        color: inherit;
    }
    .gw-btn--block {
        width: 100%;
    }
</style>
